<template>
  <div class="s2">
    <div class="container">
      <div class="story">
        <img src="@/assets/home/AhaboxStory.png" alt="" class="ahabox-story" />
        <p class="p1">
          AhaBox盲盒咖咖是2023年成立于网红城市长沙的情绪咖啡品牌，前身是拥有18年咖啡饮品行业经验的供应链公司，盲盒咖咖主打“惊喜”体验，不仅提供咖啡口感味蕾的惊喜，更让消费者通过参与感、仪式感、神秘感、满足感达到情感的惊喜。在当今都市快节奏生活下，盲盒咖咖通过独有的开箱形式将咖啡与盲盒礼物结合满足当下年轻人的情绪追求，创造另外一种疗愈。
        </p>
        <br />
        <p class="p2">
          盲盒咖咖，咖出惊喜。在这个万物皆可盲的时代，品牌将在咖啡+礼物、咖啡+文创、咖啡+城市名片、咖啡+品牌联名、咖啡+N上不断探索，提供情绪价值，不断制造惊喜，让网红品牌成为长虹品牌。
        </p>
      </div>
      <div class="s2-img-box">
        <img src="@/assets/home/s2-img.png" class="s2-img" alt="" />
      </div>
    </div>
    <div class="s2-icon-list">
      <div v-for="item in iconList" :key="item.id" class="icon-item">
        <img :src="item.icon" alt="" />
        <p>{{ item.text }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      iconList: [
        { id: 1, icon: require("@/assets/home/icon1.png"), text: "满足感" },
        { id: 2, icon: require("@/assets/home/icon2.png"), text: "仪式感" },
        { id: 3, icon: require("@/assets/home/icon3.png"), text: "神秘感" },
        { id: 4, icon: require("@/assets/home/icon4.png"), text: "分享欲" },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.s2 {
  width: 100%;
  height: 1055px;
  background: #231815;
  padding-top: 50px;
  box-sizing: border-box;
  margin: 0 auto;
  .container {
    // width: 1600px;
    height: 537.43px;
    margin: 0 auto;
    text-align: center;
    display: flex;
    justify-content: space-between;
    .story {
      // width: 782px;

      text-align: justify;
      color: #ffffff;
      font-size: 18px;
      line-height: 28px;

      p {
        text-indent: 2em;
      }
      .p1 {
        margin-top: 60px;
      }
      .ahabox-story {
        width: 441px;
        height: 55.8px;
        margin-top: 91.5px;
      }
    }
    .s2-img-box {
      position: relative;
      min-width: 566.38px;
      min-height: 505.18px;
      .s2-img {
      }
    }
  }
  .s2-icon-list {
    // width: 1600px;
    height: 238px;
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    margin-top: 90px;
    .icon-item {
      width: 190px;
      height: 238px;
      img {
        width: 190px;
        height: 190px;
      }
      p {
        font-size: 28px;
        line-height: 32px;
        text-align: center;
        color: #fff;
      }
    }
  }
}

@media screen {
  @media (min-width: 1617px) {
    .s2 {
      min-width: 1600px;
    }
    .container {
      width: 1600px;
      .story {
        width: 782px;
      }

      .s2-img-box {
        width: 603px;
        height: 538px;
        .s2-img {
          width: 603px;
          height: 538px;
        }
      }
    }
    .s2-icon-list {
      width: 1600px;
      justify-content: space-between;
    }
  }
  @media (min-width: 1201px) and (max-width: 1616px) {
    .container {
      width: 90%;
      max-width: 1600px;
      .story {
        width: calc(100% * 0.47);
        min-width: 557px;
        p {
          width: 90%;
        }
      }
      .s2-img-box {
        width: 37.68%;
      }
      .s2-img {
        width: 100%;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }
    }

    .s2-icon-list {
      width: 90%;
      max-width: 1600px;
      justify-content: space-around;
    }
  }

  @media (max-width: 1200px) {
    .s2 {
      width: 1200px;
      .container {
        width: 1100px;
        .story {
          width: 486px;
          p {
            width: 486px;
          }
        }
        // .s2-img-box {
        //   width: 566.38px;
        //   height: 505.18px;
        // }

        .s2-img-box {
          width: 37.68%;
        }
        .s2-img {
          width: 100%;
        }
      }

      .s2-icon-list {
        width: 1083px;
        justify-content: space-around;
      }
    }
  }
}
</style>
